import { useNavigate } from 'react-router-dom';
import {
  carregarEscopoUsuario,
  criaCookieToken,
  getEscopoComponentes,
  getLstDepartamentosStorage,
  montaUrlExterna,
  setBtnMaisClickadoSession,
  setDepartamentoSelecionadoSession,
  setMenuAberto,
  setTelaAberta,
  tokenIsExpired,
  refreshAccessToken,
  getMenusDepartamento,
  setMenusDepartamento,
  gravarTelaAtual
} from '../services/authentication/auth';
import { useMenuSidebar } from '../contexts/MenuSidebarContext';
import { MODULOS_TAGS } from '../components/Shared/Enums/ModulosTelasEnum';
import { ProjetosEnum } from '../components/Shared/Enums/ProjetosEnum';
import { DepartamentosEnum } from '../components/Shared/Enums/DepartamentosEnum';
import { getMenus } from '../api/autenticacao';

export const useNavegacao = ({ setEscopoAcesso }) => {
  const navigate = useNavigate();
  const {
    setLoaderGeralMain,
    setScrIframe,
    setDepartamentoSelecionado,
    setMenuOpen,
    setValueTab,
    controleItensVisiveis,
    setBtnMaisClickado,
    setScrIframeConfiguracoes,
    excluirTelaAtual
  } = useMenuSidebar();

  const navegarTelaIframe = url => {
    if (!criaCookieToken()) {
      navigate('/force-logout');
      return;
    }
    setTimeout(() => {
      setScrIframe(url);
    }, 350);
  };

  const verificaTokenExpirado = async (url, funcao) => {
    const tokenExpirado = await tokenIsExpired();
    if (tokenExpirado) {
      const refreshToken = await refreshAccessToken();
      if (refreshToken) {
        funcao(url);
      } else {
        navigate('/force-logout');
      }
    } else {
      funcao(url);
    }
  };

  const navegarTelaPadrao = rota => {
    const escopo = getEscopoComponentes();
    if (escopo && escopo?.plataforma_crm) {
      navigate(rota);
    } else {
      setLoaderGeralMain(true);
      const modulos = [
        MODULOS_TAGS.PLATAFORMA_CRM,
        MODULOS_TAGS.PLATAFORMA_ONESHELL,
        MODULOS_TAGS.PLATAFORMA_CAPITAL_FLOW,
        MODULOS_TAGS.PLATAFORMA_FORMALIZACAO,
        MODULOS_TAGS.PLATAFORMA_RELACIONAMENTOS
      ];

      return carregarEscopoUsuario(modulos, setEscopoAcesso)
        .then(() => navigate(rota))
        .finally(() => setLoaderGeralMain(false));
    }
  };

  const navegarTela = (menu, rota, projeto, codDepartamento = false, params = '') => {
    excluirTelaAtual();
    const telaConfiguracoes = parseInt(codDepartamento) === parseInt(DepartamentosEnum.CONFIGURACOES);
    const parametroConf = telaConfiguracoes ? '-conf' : '';

    projeto = parseInt(projeto);
    const url = montaUrlExterna(rota, projeto, params);
    gravarTelaAtual({ menu, rota, projeto, sufix: parametroConf });

    if (telaConfiguracoes) {
      verificaTokenExpirado(url, navegarTelaConfiguracoes);
    } else {
      if (
        Object.values(ProjetosEnum)
          .filter(v => v !== ProjetosEnum.PLATAFORMA_CRM)
          .includes(projeto)
      ) {
        verificaTokenExpirado(url, navegarTelaIframe);
      } else {
        navegarTelaPadrao(rota);
      }
      if (codDepartamento) {
        const lstDepartamentosSessionStorage = getLstDepartamentosStorage();

        if (lstDepartamentosSessionStorage && lstDepartamentosSessionStorage.length > 0) {
          const index = lstDepartamentosSessionStorage.findIndex(
            dep => parseInt(dep.id) === parseInt(codDepartamento)
          );

          if (index || index >= 0) {
            setDepartamentoSelecionadoSession(lstDepartamentosSessionStorage[index]);
            if (index < controleItensVisiveis) {
              setValueTab(index);
            } else if (index >= controleItensVisiveis) {
              setBtnMaisClickado(true);
              setBtnMaisClickadoSession();
            }
          }
          setDepartamentoSelecionado(codDepartamento);
        }
      }

      setMenuOpen(false);
    }

    setTelaAberta(rota);
    setMenuAberto(menu);
  };

  const navegarAbrirTela = ({ evento, menu, rota, projeto, codDepartamento = false }) => {
    evento.preventDefault();
    projeto = parseInt(projeto);
    if (
      (evento.ctrlKey || evento.metaKey || evento.button === 1) &&
      (projeto === ProjetosEnum.ISEVEN || projeto === ProjetosEnum.MODULUS)
    ) {
      if (!criaCookieToken()) {
        navigate('/force-logout');
        return;
      }
      const url = montaUrlExterna(rota, parseInt(projeto));
      window.open(url, '_blank');
    } else {
      navegarTela(menu, rota, projeto, codDepartamento);
    }
  };

  const getDadosSubMenu = async (idDep, idSubMenu) => {
    let menusDep = getMenusDepartamento(idDep);
    if (!menusDep) {
      menusDep = await getSetMenusPrincipais({ codDepartamento: idDep });
    }
    const subMenuEncontrado = menusDep
      ?.flatMap(menu => menu.subMenus || [])
      .find(subMenu => parseInt(subMenu.id) === parseInt(idSubMenu));

    return subMenuEncontrado || null;
  };

  const getSetMenusPrincipais = async ({
    codDepartamento,
    fnSetData = () => {},
    fnLoading = () => {},
    loading = true
  }) => {
    if (!codDepartamento) return false;
    let result;
    fnLoading(loading);
    await getMenus(codDepartamento)
      .then(dados => {
        result = dados.data;
        fnSetData(result);
        setMenusDepartamento(codDepartamento, result);
      })
      .catch(() => {})
      .finally(() => {
        fnLoading(false);
      });
    return result;
  };

  const navegarTelaConfiguracoes = url => {
    if (!criaCookieToken()) {
      navigate('/force-logout');
      return;
    }
    navigate('/configuracoes');
    setTimeout(() => {
      setScrIframeConfiguracoes(url);
    }, 350);
  };

  return {
    navegarTela,
    navegarTelaIframe,
    navegarTelaPadrao,
    navegarAbrirTela,
    getDadosSubMenu,
    getSetMenusPrincipais
  };
};
